/**
 * Created by A on 2/22/2017.
 */
BookingApp.controller('HotelListingController',function($scope,$routeParams,$location){
    $scope.Hotels = $scope.$resolve.HotelList;
    //console.log($route.current.originalPath);

    $scope.OldQ = $routeParams.q;
    $scope.queryString = {
        q   :   $routeParams.q,
        mnp :   $routeParams.mnp,
        mxp :   $routeParams.mxp,
        star:   $routeParams.star,
        limit:  $routeParams.limit,
        page:   $routeParams.page
    }


    //init();
    $scope.init = function() {
        $scope.hotels = $scope.$resolve.HotelList.hotels;
        $scope.trace = $scope.$resolve.HotelList.TraceId;


        $scope.Filters = {
            Price :  {
                options:{
                    floor:$scope.$resolve.HotelList.MinPrice,
                    ceil:$scope.$resolve.HotelList.MaxPrice,
                    step:1,
                    translate: function(value) {
                        return '<i class="fa fa-rupee"></i> ' + value;
                    },
                    onEnd:function(){
                        $scope.updateSearch();
                    }
                }
            }
        };
        if($scope.queryString.mnp == 0){ $scope.queryString.mnp =  $scope.$resolve.HotelList.MinPrice }
        if($scope.queryString.mxp == 0){ $scope.queryString.mxp =  $scope.$resolve.HotelList.MaxPrice }
        //console.log($scope.queryString);

    }
    $scope.init();

    $scope.reset = function(){
        $location.search({q:'',mnp:0,mxp:0,star:'',limit:10,page:1});
    }

    $scope.AddRating = function(val){

        var index = $scope.queryString.star.indexOf(val);
        if(index === -1){
            $scope.queryString.star += val;
        }else{
            console.log($scope.queryString.star);
            $scope.queryString.star = $scope.queryString.star.replace(val,"");
            console.log($scope.queryString.star);
        }
        $scope.updateSearch();
    }

    $scope.updateSearch = function(){
        $scope.queryString.page = 1;
        $location.search($scope.queryString);
    }

    //Listen child controller loaded event to fire and set request in it
    $scope.$on('HotelSearchControllerLoaded',function(event,param){
        $scope.$broadcast('set-search-data',$scope.$resolve.HotelList);
    })

    $scope.SearchByName = function(){
        $scope.updateSearch()
    }

    $scope.pageChanged = function(){
        $location.search($scope.queryString);
    }

    $scope.clearSearch = function(){
        $scope.queryString.q = "";
        $scope.updateSearch()
    }

});


BookingApp.filter('HotelFilter',function(){
    return function(input,Filter){
        return input;
        var FilteredData = []

        angular.forEach(input,function(value,key){
            if(
                (!Filter.StarRating.length || Filter.StarRating.indexOf(value.StarRating) != -1) &&
                (Filter.Price.minPrice < value.Price && Filter.Price.maxPrice > value.Price)
            ){
                FilteredData.push(value);
            }
        });

        return FilteredData;
    }
})




